import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';

import Route from 'routes/Route';
import Content from './Content';
import Prospect from './Prospect';
import Unsubscribe from './Unsubscribe';
import Maintenance from './Maintenance';
import Version from './Version';

const Public = () => {
    return (
        <Suspense fallback={<div />}>
            <Switch>
                <Route isPublic path="/public/content" render={props => <Content {...props} />} />
                <Route
                    isPublic
                    path="/public/unsubscribe"
                    render={props => <Unsubscribe {...props} />}
                />
                <Route isPublic path="/public/prospect" render={props => <Prospect {...props} />} />
                <Route
                    isPublic
                    path="/public/maintenance"
                    render={props => <Maintenance {...props} />}
                />
                <Route isPublic path="/public/version" render={props => <Version {...props} />} />
            </Switch>
        </Suspense>
    );
};

export default Public;
